import { useCallback, useEffect, useState } from 'react'
import * as React from 'react'
import DialogButton from '../../Common/Buttons/DialogButton'
import Dialog from '../../Common/Dialog/Dialog'
import DialogActions from '../../Common/Dialog/DialogActions'
import DialogContent from '../../Common/Dialog/DialogContent'
import { type UserProductDesignStore } from '../../UserData/_stores/UserProductDesignStore'
import { RenamePaginationItem } from '../../UserData/_actions/UserDataActions'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '../../Common/_hooks/useAppDispatch'
import { TextField } from '@mui/material'
import DialogTitle from '../../Common/Dialog/DialogTitle'

interface Props {
  productDesign: UserProductDesignStore
  opened: boolean
  onClose: () => void
}

export default function RenameDesignDialog(props: Props) {
  const [t] = useTranslation('account-v2')
  const dispatch = useAppDispatch()

  const [name, setName] = useState(props.productDesign.get('name'))

  useEffect(() => {
    setName(props.productDesign.get('name'))
  }, [props.productDesign])

  const resetDialogState = useCallback(() => {
    setName(props.productDesign.get('name'))
  }, [props.productDesign])

  const onClose = useCallback(() => {
    props.onClose()
  }, [props.onClose])

  const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value)
  }, [])

  const onSubmit = useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    const fd = new FormData()
    fd.append('id', String(props.productDesign.get('id_product_design')))
    fd.append('name', name)

    dispatch(RenamePaginationItem(fd, 'productDesigns'))
    onClose()
  }, [props.productDesign, onClose, name])

  return <Dialog
    open={props.opened}
    maxWidth="xs"
    fullWidth
    onClose={onClose}
    TransitionProps={{
      onExited: resetDialogState,
    }}
    showCloseButton
  >
    <form onSubmit={onSubmit}>
      <DialogTitle>{t('Rename Product')}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          variant="filled"
          label={t('Name')}
          value={name}
          onChange={onChange}
        />
      </DialogContent>
      <DialogActions>
        <DialogButton
          color="secondary"
          onClick={onClose}
        >{t('Cancel')}</DialogButton>
        <DialogButton
          color="primary"
          type="submit"
          disabled={name === ''}
        >{t('Confirm')}</DialogButton>
      </DialogActions>
    </form>
  </Dialog>
}
